import { render, staticRenderFns } from "./Pastas.vue?vue&type=template&id=f9de7e7a&scoped=true&"
import script from "./Pastas.vue?vue&type=script&lang=js&"
export * from "./Pastas.vue?vue&type=script&lang=js&"
import style0 from "./Pastas.vue?vue&type=style&index=0&id=f9de7e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9de7e7a",
  null
  
)

export default component.exports